import React from "react";
import styles from './Contact.module.css';
import emailjs from 'emailjs-com';

const Contact = () => {
    function send(e) {
        e.preventDefault();

        emailjs.sendForm('service_cch94rh', 'template_mbqlfis', e.target, 'Hk7qfsTBwt5gunnI0')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    }
    return (
        <>
            <div id="contact" className={styles.about}>
                <div className="container">
                    <h1>Contactez Nous :</h1>
                    <div className={styles.cont}>
                        <div className={styles.img}>
                        </div>
                        <div className={styles.text}>
                            <h4>Dit Bonjour!</h4>
                            <form onSubmit={send} action="" method="post">
                                <input type="text" name="nom" placeholder="     Nom" />
                                <input type="email" name="email" placeholder="     votre email" />
                                <textarea className={styles.msg} name="sms" placeholder="     Message ..." />

                                <button>Envoyer</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;